import { gql } from "@apollo/client";

export const GET_TENANT_NOTIFICATIONS = gql`
  query TenantNotifications($page_number: Int = 1, $limit: Int = 20, $filter: NotificationFilterInput) {
    tenantNotifications(page_number: $page_number, limit: $limit, filter: $filter) {
      nodes {
        _id
        tenant_id
        account_id
        type
        title
        message
        metadata
        is_read
        read_at
        createdAt
        category
      }
      total_count
      unread_count
    }
  }
`;

export const GET_TENANT_NOTIFICATION_COUNT = gql`
  query TenantUnReadNotificationCount {
    tenantUnReadNotificationCount {
      unread_count
    }
  }
`;

export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription NotificationReceived($tenant_id: String!) {
    notificationReceived(tenant_id: $tenant_id) {
      _id
      tenant_id
      account_id
      type
      title
      message
      metadata
      is_read
      read_at
      createdAt
      category
    }
  }
`;


